const DATE_FORMAT = new Intl.DateTimeFormat('es-AR', {
  timeZone: 'UTC',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const DATE_TIME_DATE_PART = new Intl.DateTimeFormat('es-AR', {
  timeZone: 'America/Argentina/Buenos_Aires',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

const DATE_TIME_TIME_PART = new Intl.DateTimeFormat('es-AR', {
  timeZone: 'America/Argentina/Buenos_Aires',
  hourCycle: 'h23',
  hour: '2-digit',
  minute: '2-digit',
});

/**
 * Formats a calendar day (service date) as `dd/mm/aaaa`, read in UTC.
 *
 * The API sends these as UTC midnight; reading them in the browser's zone
 * would move every date one day back in Argentina (UTC-3), same reasoning as
 * `apps/web-admin/src/orders/format-calendar-date.ts`. Deliberately not
 * shared with `formatDateTime`, which reads real instants in the browser's
 * zone instead.
 */
export function formatDate(value: string | Date): string {
  return DATE_FORMAT.format(new Date(value));
}

/**
 * Formats a real instant (e.g. `signedAt`, `cutoffAt`) as `dd/mm/aaaa HH:mm`
 * in Argentina's zone, 24-hour clock. Unlike `formatDate`, this is not read
 * in UTC: a timestamp is a specific moment, not a calendar day.
 */
export function formatDateTime(value: string | Date): string {
  const date = new Date(value);
  return `${DATE_TIME_DATE_PART.format(date)} ${DATE_TIME_TIME_PART.format(date)}`;
}
